import React from 'react';
import { useNavigate } from 'react-router';

import styles from './styles.module.css';
import PowerIcon from '../../assets/icons/power.svg?react';

interface LocationCardProps {
  id: string;
  title: string;
  subtitle: string;
  value: number;
  unit?: string;
}

const LocationCard: React.FC<LocationCardProps> = ({
  id,
  title,
  subtitle,
  value,
  unit = 'MW'
}) => {
  const navigate = useNavigate();

  const formatNumber = (num: number): string => {
    return Number(num.toFixed(2)).toString();
  };

  const handleClick = () => {
    navigate(`/locations/${id}?name=${encodeURIComponent(title)}`);
  };

  return (
    <div className={styles.card} onClick={handleClick}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <PowerIcon className={styles.icon} />
        </div>
        <div className={styles.valueContainer}>
          <span className={styles.value}>{formatNumber(value)}</span>
          <span className={styles.unit}>{unit}</span>
        </div>
      </div>
    </div>
  );
};

export default LocationCard;
